// Plate calculator + 5lb rounding helpers.
// Greedy fill from heaviest plate down; only standard US-imperial plate denominations.

export const PLATE_DENOMS = [45, 35, 25, 10, 5, 2.5];

export function roundTo5(value) {
    if (!value || Number.isNaN(Number(value))) return 0;
    return Math.round(Number(value) / 5) * 5;
}

/**
 * Compute per-side plate stack to reach `target` total weight on a bar of `barWeight`.
 * Returns array of {plate, count} stacked from heaviest first, OR null if no bar/equipment,
 * OR [] if the target is at-or-below bar weight (no plates needed).
 */
export function computePlates(target, barWeight) {
    if (!target || target <= 0) return null;
    if (!barWeight || barWeight <= 0) return null;
    const perSide = (Number(target) - Number(barWeight)) / 2;
    if (perSide <= 0) return [];
    const result = [];
    let remaining = perSide;
    for (const plate of PLATE_DENOMS) {
        const count = Math.floor((remaining + 1e-6) / plate);
        if (count > 0) {
            result.push({ plate, count });
            remaining = +(remaining - count * plate).toFixed(2);
        }
    }
    // If remaining is non-zero, we couldn't make it exactly with whole plates.
    return result;
}

export function formatPlates(plates) {
    if (!plates) return "";
    if (plates.length === 0) return "Just the bar";
    return plates.map((p) => `${p.plate}×${p.count}`).join(", ");
}
